import { render, staticRenderFns } from "./HotelSalesWidget.vue?vue&type=template&id=6064cff7&"
import script from "./HotelSalesWidget.vue?vue&type=script&lang=js&"
export * from "./HotelSalesWidget.vue?vue&type=script&lang=js&"
import style0 from "./HotelSalesWidget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports